import { render } from "./designGroupTitlePreview.vue?vue&type=template&id=2dc612b6&scoped=true"
import script from "./designGroupTitlePreview.vue?vue&type=script&lang=js"
export * from "./designGroupTitlePreview.vue?vue&type=script&lang=js"

import "./designGroupTitlePreview.vue?vue&type=style&index=0&id=2dc612b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc612b6"]])

export default __exports__